export default {
  showProfiles: ({ showId }) => ['show', showId, 'profiles'],
  showProfile: ({ showId, profileId }) => ['showId', showId, 'profile', profileId],
};
